class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);













// window.addEventListener('DOMContentLoaded', () => {
//   const wrapper = document.querySelector('.facets-vertical-sort');
//   const header = document.querySelector('.header-wrapper');

//   if (wrapper && header) {
//     const headerHeight = header.offsetHeight || 0;
//     const offsetTop = headerHeight - 2; // Subtract 2px

//     // Apply sticky style directly to the wrapper (no parent div)
//     wrapper.style.position = 'sticky';
//     wrapper.style.top = `${offsetTop}px`;
//     wrapper.style.zIndex = '1'; // Optional
//     wrapper.style.background = 'white'; // Optional
//     wrapper.style.padding = '15px'; // Optional
//   }
// });


document.querySelector('.mobile-facets__open-wrapper')?.addEventListener('click', function() {
  document.querySelector('.facets-wrapper').classList.toggle('active_index');
});


if (window.matchMedia("(max-width:1024px)").matches) {
  document.addEventListener("DOMContentLoaded", function () {
    const addToCartContainer = document.querySelector(".facets-wrapper");
    const header = document.querySelector('.header-wrapper');
    const heroText = document.querySelector('.collection-hero__text-wrapper');
  
    // Make sure header and heroText exist
    if (!header || !heroText || !addToCartContainer) return;
  
    const headerHeight = header.offsetHeight;
    const heroTextHeight = heroText.offsetHeight;
    const extraPadding = 0; // your additional padding
    const totalHeight = headerHeight + heroTextHeight + extraPadding;
  
    window.addEventListener("scroll", function () {
      if (window.scrollY > totalHeight) {
        addToCartContainer.classList.add("sticky-show");
      } else {
        addToCartContainer.classList.remove("sticky-show");
      }
    });
  });
}


window.addEventListener('DOMContentLoaded', () => {
  if (window.matchMedia("(min-width: 1024px)").matches) {
    const wrapper = document.querySelector('.facets-wrapper');
    const header = document.querySelector('.header-wrapper');

    if (wrapper && header) {
      const parentAside = wrapper.closest('aside');

      if (parentAside) {
        const headerHeight = header.getBoundingClientRect().height || 0;
        const offsetTop = Math.max(0, headerHeight - 1); // Ensures no negative value

        parentAside.style.position = 'sticky';
        parentAside.style.top = `${offsetTop}px`;
        parentAside.style.zIndex = '2'; // Optional styling
        // parentAside.style.background = 'white'; // Optional styling
      }
    }
  }
});


window.addEventListener('DOMContentLoaded', () => {
  if (window.matchMedia("(max-width: 1024px)").matches) {
    const wrapper = document.querySelector('.ctm-vertical');
    const header = document.querySelector('.header-wrapper');

    if (wrapper && header) {
      const parentAside = wrapper.closest('aside');

      if (parentAside) {
        const headerHeight = header.getBoundingClientRect().height || 0;
        const offsetTop = Math.max(0, headerHeight - 1); // Ensures no negative value

        parentAside.style.position = 'sticky';
        parentAside.style.top = `${offsetTop}px`;
        parentAside.style.zIndex = '2'; // Optional styling
        // parentAside.style.background = 'white'; // Optional styling
      }
    }




    
  }
});

window.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.facets-vertical-sort');
  const header = document.querySelector('.header-wrapper');

  if (wrapper && header) {
    const headerHeight = header.offsetHeight || 0;
    const offsetTop = headerHeight - 2; // Subtract 2px

    // Apply sticky style directly to the wrapper (no parent div)
    wrapper.style.position = 'sticky';
    wrapper.style.top = `${offsetTop}px`;
    wrapper.style.zIndex = '1'; // Optional
    // wrapper.style.background = 'white'; // Optional
    wrapper.style.padding = '15px'; // Optional
  }
});